import React from 'react';

const Step5Upload = ({
  formData,
  formErrors,
  handleProfileImageUpload,
  handleRemoveProfileImage,
  handleResumeUpload,
  handleRemoveResume,
  handleOtherDocumentsUpload,
  handleRemoveOtherDocument,
  isSubmitting
}) => {
  const getFileIcon = (fileName) => {
    const extension = fileName?.split('.').pop().toLowerCase();
    const iconMap = {
      'pdf': '📄', 'doc': '📝', 'docx': '📝', 'jpg': '🖼️', 'jpeg': '🖼️',
      'png': '🖼️', 'gif': '🖼️', 'xls': '📊', 'xlsx': '📊', 'ppt': '🪧',
      'pptx': '🪧', 'txt': '📝',
    };
    return iconMap[extension] || '📎';
  };

  return (
    <>

      <div className="upload-section">
        {/* Profile Image Upload */}
        <div className="upload-card">
          <h4>Profile Image <span className="required-star">*</span></h4>
          <p className="upload-description">Upload a recent passport size photo (JPG or PNG)</p>
          <div className={`upload-area ${formData.profileImage ? 'has-file' : ''}`}>
            <input
              id="profileImageInput"
              type="file"
              accept=".jpg,.jpeg,.png"
              onChange={handleProfileImageUpload}
              disabled={isSubmitting}
            />
            {formData.profileImage ? (
              <div className="file-selected" style={{ width: '100%', boxSizing: 'border-box' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1, overflow: 'hidden' }}>
                  <div className="profile-preview">
                    <img
                      src={formData.profileImagePreview}
                      alt="Profile"
                      className="profile-image-preview"
                    />
                  </div>
                  <span className="file-name" title={formData.profileImage}>{formData.profileImage}</span>
                </div>
                <div className="file-actions">
                  <button
                    type="button"
                    className="update-file"
                    onClick={() => document.getElementById('profileImageInput').click()}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    className="remove-file"
                    onClick={handleRemoveProfileImage}
                  >
                    ✕
                  </button>
                </div>
              </div>
            ) : (
              <>
                <p>Click or Drag to upload profile image</p>
                <span className="file-types">JPG, PNG only</span>
              </>
            )}
          </div>
          {formErrors.profileImage && <p className="application-error">{formErrors.profileImage}</p>}
        </div>

        {/* Resume Upload */}
        <div className="upload-card">
          <h4>Resume / CV <span className="required-star">*</span></h4>
          <p className="upload-description">Upload your updated resume (PDF, DOC, or DOCX)</p>
          <div className={`upload-area ${formData.resume ? 'has-file' : ''}`}>
            <input
              id="resumeInput"
              type="file"
              accept=".pdf,.doc,.docx"
              onChange={handleResumeUpload}
              disabled={isSubmitting}
            />
            {formData.resume ? (
              <div className="file-selected" style={{ width: '100%', boxSizing: 'border-box' }}>
                <span className="file-name" title={formData.resume}>📄 {formData.resume}</span>
                <div className="file-actions">
                  <button
                    type="button"
                    className="update-file"
                    onClick={() => document.getElementById('resumeInput').click()}
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    className="remove-file"
                    onClick={handleRemoveResume}
                  >
                    ✕
                  </button>
                </div>
              </div>
            ) : (
              <>
                <p>Click or Drag to upload resume</p>
                <span className="file-types">PDF, DOC, DOCX</span>
              </>
            )}
          </div>
          {formErrors.resume && <p className="application-error">{formErrors.resume}</p>}
        </div>

        {/* Other Documents Upload */}
        <div className="upload-card full-width">
          <h4>Other Documents</h4>
          <p className="upload-description">Upload any additional documents (ID proof, certificates, etc.)</p>
          <div className="upload-area">
            <input
              type="file"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              multiple
              onChange={handleOtherDocumentsUpload}
              disabled={isSubmitting}
            />
            <p>Click or Drag to upload multiple documents</p>
            <span className="file-types">PDF, DOC, DOCX, JPG, PNG</span>
          </div>

          {/* Other Documents List */}
          {formData.otherDocuments && formData.otherDocuments.length > 0 && (
            <div className="other-documents-list">
              <h5>Uploaded Documents ({formData.otherDocuments.length})</h5>
              {formData.otherDocuments.map((doc, index) => (
                <div key={index} className="document-item">
                  <span className="file-name">{getFileIcon(doc.name)} {doc.name}</span>
                  <button
                    type="button"
                    className="remove-file"
                    onClick={() => handleRemoveOtherDocument(index)}
                  >
                    ✕ Remove
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Document Preview Section */}
        {(formData.profileImage || formData.resume || (formData.otherDocuments && formData.otherDocuments.length > 0)) && (
          <div className="upload-summary full-width">
            <h4>Upload Summary</h4>
            <div className="summary-grid">
              {formData.profileImage && (
                <div className="summary-item">
                  <span className="summary-label">Profile Image:</span>
                  <span className="summary-value">Uploaded ✓</span>
                </div>
              )}
              {formData.resume && (
                <div className="summary-item">
                  <span className="summary-label">Resume:</span>
                  <span className="summary-value">Uploaded ✓</span>
                </div>
              )}
              {formData.otherDocuments && formData.otherDocuments.length > 0 && (
                <div className="summary-item">
                  <span className="summary-label">Other Documents:</span>
                  <span className="summary-value">{formData.otherDocuments.length} file(s) ✓</span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Step5Upload;